<div class="center-xs custom_modal">
  <div class="modal-head" [innerHTML]="data.headerTranslationCode | translate: data" [ngClass]="data.type"></div>

  <div class="modal-body" [innerHTML]="data.bodyTranslationCode | translate: data"></div>

  <div class="modal-buttons">
    <eps-button
      (buttonClick)="gotoOverviewAndClose()"
      [label]="data.overviewButtonText"
      buttonIcon="angle-left"
      [minWidth]="(extraSmallScreenOrLess$ | async) && '190px' || '0'"
      ></eps-button>
    <eps-button
      (buttonClick)="gotoDetailAndClose()"
      [label]="data.detailButtonText"
      [minWidth]="(extraSmallScreenOrLess$ | async) && '190px' || '0'"
      buttonIcon="eye"
      *ngIf="data.type === 'success' && !data.disableClose"
    ></eps-button>
    <eps-button
      (buttonClick)="downloadAndClose()"
      [label]="data.downloadButtonText"
      [minWidth]="(extraSmallScreenOrLess$ | async) && '190px' || '0'"
      buttonIcon="download"
      *ngIf="data.type === 'success' && data.showDownloadDocumentButton"
      ></eps-button>
    <eps-button
      (buttonClick)="createAndClose()"
      [label]="data.createButtonText"
      [minWidth]="(extraSmallScreenOrLess$ | async) && '190px' || '0'"
      buttonIcon="plus"
      *ngIf="data.type === 'success' && data.showCreateButton"
    ></eps-button>
    <eps-button
      (buttonClick)="copyAndClose()"
      [label]="data.copyButtonText"
      [minWidth]="(extraSmallScreenOrLess$ | async) && '190px' || '0'"
      buttonIcon="clipboard"
      *ngIf="data.type === 'success' && data.showCopyButton"
      ></eps-button>
  </div>
</div>
